import FeatureFlagsReducer from './components/featureFlags/reducer';
import loadingReducer from './store/reducers/loading';
import messagesReducer from './store/reducers/messages';

export const commonReducers = {
  loading: loadingReducer,
  messages: messagesReducer,
  featureFlags: FeatureFlagsReducer,
};
